var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"flex-dropdown-box",style:({ width: _vm.width + 'px', top: _vm.posTop + 'px', left: _vm.posLeft + 'px', position: 'absolute' })},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }